import { Button, IcChevronLeft, Text } from '@fozito/common-ui';
import fozito_Logo from 'assets/logo.svg';
import useChooseStore from 'modules/auth/hooks/useChooseStore';
import authSelectors from 'modules/auth/services/selectors';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import CardInfo from './CardInfo';
import authActions from 'modules/auth/services/actions';

const StoreSelectionPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const shops = authSelectors.owner.getShops();
  const chooseStore = useChooseStore();

  const onBackHome = () => {
    dispatch(authActions.ownerLogout());
    storage.token.set('');
    storage.shop_id.set('');
    navigate('/sign-in');
  };

  return (
    <Container>
      <Header>
        <img src={fozito_Logo} alt='fozito_Logo' height={64} />
        <Button type='button' type_cancel onClick={onBackHome}>
          <div className='btn-back'>
            <IcChevronLeft />
            <Text>Back</Text>
          </div>
        </Button>
      </Header>
      <Wrapper>
        <Content>
          {shops.length > 0 && (
            shops.map((store) => (
              <CardInfo
                key={store.id}
                store={store}
                onClick={() => chooseStore(store)}
              />
            ))
          )}
        </Content>
      </Wrapper>
    </Container>
  );
};

export default StoreSelectionPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  gap: 20px;
  background-color: #F5F5F5;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 40px;

  .btn-back {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 1576px;
  padding: 24px;
  gap: 32px;
`;